import {useEffect} from 'react'
import {withRouter, matchPath} from 'react-router-dom'
import useGetDeviceKey from './Orders/useGetDeviceKey'
import useTracker, {touchDevice} from './Orders/useTracker'
import useRemoteControl from './Orders/useRemoteControl'

// Mounted once at the app root so every route is tracked, not just the
// tablet order screen. Renders nothing.
function DeviceTracker ({location}) {
  const match = matchPath(location.pathname, {path: '/r/:r_id'})
  const r_id = match ? match.params.r_id : null

  const deviceKey = useGetDeviceKey()
  useTracker(r_id, deviceKey)
  useRemoteControl(r_id, deviceKey)

  // Route changes inside the SPA (admin navigation) don't reconnect, so
  // record the new path directly.
  const fullPath = location.pathname + location.search
  useEffect(() => {
    touchDevice(deviceKey, r_id)
  }, [deviceKey, r_id, fullPath])

  return null
}

export default withRouter(DeviceTracker)
